<template>
  <el-dialog :title="$t('854')" append-to-body :visible.sync="visible" :close-on-click-modal="false" width="1000px">
    <gmap-map :options="googleOptions" :center="centers" ref="mapRef" :zoom="12" class="google-map">
      <gmap-marker :draggable="true" />
    </gmap-map>
    <el-row style="margin-top: 20px">
      <span style="margin-right: 45px">{{ $t('2333') }}</span>
      <el-input disabled style="width: 240px; margin-right: 20px" v-model="currentMap.name" :placeholder="$t('2333')" />
      <span style="margin-right: 45px">{{ $t('534') }}</span>
      <el-input
        type="number"
        style="width: 180px; margin-right: 20px"
        v-model="range"
        :placeholder="$t('534')"
        @input="handleEnterNumber"
      />
      <el-button type="parimary" @click="handlerAddList">{{ $t('635') }}</el-button>
    </el-row>
    <el-form style="margin-top: 10px" label-width="100px" label-position="left">
      <el-form-item :label="$t('855')">
        <div v-for="(item, index) in areaList" :key="index">
          <el-tag closable @close="handleClose(index)"
            >{{ item.name }} {{ $t('581', { key: item.range || 0 }) }}</el-tag
          >
        </div>
      </el-form-item>
    </el-form>
    <!-- 地址列表 -->
    <div class="position-wrap" v-if="positionList.length">
      <ul>
        <li v-for="(item, index) in positionList" :key="index">
          <h3 class="border-bottom" @click="changeCurrent(item)">
            <i> <img class="position-icon" :src="item.icon" /></i>
            <span>{{ item.formatted_address }}</span>
          </h3>
          <img v-if="item.photos" class="position-img" :src="item.photos[0].getUrl()" />
          <!-- <img
            class="position-img"
            :src="current.getUrl()"
            alt=""
            v-for="(current, index) in item.photos"
            :key="index"
          /> -->
        </li>
      </ul>
    </div>
    <!-- 确认取消 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('66') }}</el-button>
      <el-button type="primary" plain @click="confirm">{{ $t('131') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import { utilCookies } from '@/util/cookies'
// 谷歌地图key
const key = 'AIzaSyArw4avyMPteftN-tVZHOO8VXiPiYImbzQ'
// 注册谷歌地图
Vue.use(VueGoogleMaps, {
  load: {
    key,
    libraries: 'places',
    region: 'VI', // 这个地区自己定
    language: utilCookies.getLanguage() || 'th' // 这个语言自己定
  },
  installComponents: true
})
// 谷歌地图api调用
import { gmapApi } from 'vue2-google-maps'
import store from 'storejs'
const lang = store.get('language')
const bases = {
  id: {
    lat: -6.2099463789942195,
    lng: 106.84221916284554,
    name: 'Jakarta'
  },
  other: {
    lat: 13.749978051743666,
    lng: 100.4913183032852,
    name: 'พระบรมมหาราชวัง'
  }
}

export default {
  props: {
    area: {
      type: Array,
      default: () => []
    }
  },
  components: {},
  data() {
    return {
      googleOptions: {
        scaleControl: false,
        zoom: 14,
        // 是否展示地图默认组件
        mapTypeControl: false
      },
      visible: false,
      options: [],
      areaList: [],
      range: '',
      marker: '',
      // 印尼语默认地址 其他语言默认泰国
      centers: bases[lang] || bases.other,
      currentMap: {},
      position: {},
      positionList: []
    }
  },
  watch: {
    visible(v) {
      if (v) {
        if (this.area && this.area.length > 0) {
          // this.positionList
          this.areaList = this.area.map(item => {
            return {
              lng: item.area_lng || item.lng,
              lat: item.area_lat || item.lat,
              name: item.area_name || item.name,
              range: item.range || ''
            }
          })
        }
        this.$nextTick(() => {
          if (!this.map) this.getMapExample()
          this.map && this.areaList[0] && this.changePosition(this.areaList[0])
        })
      }
    }
  },
  computed: {
    google: gmapApi
  },
  methods: {
    // 打卡范围大于0限制
    handleEnterNumber(e) {
      e = Number(e)
      if (e < 0) this.range = 0
    },
    // 创建搜索框 监听输入
    createSearch() {
      // Create the search box and link it to the UI element.
      const input = document.createElement('input')
      input.className = 'el-input__inner'
      input.setAttribute('style', 'width: 316px; transform: translate(10px, 10px); height: 36px; z-index: 1000000')
      this.searchBox = new this.google.maps.places.SearchBox(input)
      this.map.controls[this.google.maps.ControlPosition.TOP_LEFT].push(input)
      // Bias the SearchBox results towards current map's viewport.
      this.map.addListener('bounds_changed', () => {
        this.searchBox.setBounds(this.map.getBounds())
      })
      this.searchBox.addListener('places_changed', () => {
        const places = this.searchBox.getPlaces()
        // console.log(places)
        this.positionList = places
        const location = places[0].geometry.location
        if (places.length == 0) {
          return
        }
        this.currentMap = {
          lat: location.lat(),
          lng: location.lng(),
          name: places[0].formatted_address,
          title: places[0].formatted_address
        }
        this.changePosition(this.currentMap)
      })
    },
    // 获取实例
    getMapExample() {
      this.$refs.mapRef.$mapPromise.then(map => {
        // 谷歌地图实例话对象
        this.map = map
        this.createSearch()
        this.areaList[0] && this.changePosition(this.areaList[0])
      })
    },
    // 删除列表项
    handleClose(num) {
      this.areaList.splice(num, 1)
    },
    // 定位
    changePosition(area) {
      this.centers = {
        lat: parseFloat(area.lat),
        lng: parseFloat(area.lng),
        title: area.name,
        name: area.name
      }
      // 更换位置
      this.map.panTo(this.centers || this.currentMap)
      this.Marker && this.Marker.setMap(null)
      // 添加标记
      this.Marker = new this.google.maps.Marker({
        position: this.centers,
        // draggable: true,  // 标记拖拽
        map: this.map
      })
      // 标记可拖拽
      // this.google.maps.event.addListener(this.Marker, 'dragend', function (MouseEvent) {
      //   alert(MouseEvent.latLng)
      // })
    },
    handlerAddList() {
      if (Object.keys(this.currentMap).length && this.range) {
        this.currentMap.range = this.range
        this.areaList.push(this.currentMap)
        // this.currentMap = {}
        this.range = ''
        this.position = {}
      } else {
        this.$notify.info({
          title: this.$t('229'),
          message: this.$t('858')
        })
      }
    },
    changeCurrent(params) {
      const location = params.geometry.location
      this.currentMap = {
        lat: location.lat(),
        lng: location.lng(),
        name: params.formatted_address,
        title: params.formatted_address
        // area_lat: location.lat(),
        // area_lng: location.lng(),
        // area_name: params.formatted_address
      }
      this.changePosition(this.currentMap)
    },
    confirm() {
      this.visible = false
      this.$emit('changeMap', this.areaList)
    }
  }
}
</script>

<style lang="less" scoped>
@import url('~leaflet/dist/leaflet.css');
.google-map {
  width: 100%;
  height: 500px;
}
.position-icon {
  width: 20px;
  height: 20px;
  line-height: 20px;
  margin-right: 5px;
  vertical-align: text-bottom;
  transform: translateY(-3px);
}
.position-wrap {
  width: 315px;
  padding: 20px 0;
  position: absolute;
  left: 30px;
  top: 80px;
  background: white;
  max-height: 440px;
  overflow: auto;
  border-radius: 4px;
}
.position-img {
  width: calc(100% - 40px);
  border-radius: 5px;
  display: inline-block;
  margin: 20px;
}
.border-bottom {
  border-bottom: 1px solid #f1ebeb;
  padding: 15px 20px;
  cursor: pointer;
  margin: 0;
  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
}
/deep/ .el-dialog {
  max-width: 1200px;
}
</style>

<style>
.el-dialog__body {
  position: relative;
}
.search-wrap {
  width: 300px;
  height: 100%;
  background: #000;
}
.pac-container {
  z-index: 10000 !important;
}
.pac-logo::after {
  background-image: inherit;
}
</style>
